<div class="log__container">
  <div class="log__label">{{ log.label }}</div>
  <div *ngIf="log.type === 'text' || log.type === 'date'" class="log__value strong">
    {{ log.text }}
  </div>
  <div *ngIf="log.type === 'rule'" class="log__value strong">
    <a class="ocean clickable" (click)="openRule(log.ruleset_id, log.event_type)">{{ log.name }}</a>
  </div>
  <div *ngIf="log.type === 'log'" class="log__value strong">
    <a class="ocean clickable" (click)="openLog(log.randomkey, log.event_type)">{{ log.name }}</a>
  </div>
  <div *ngIf="log.type === 'text-link'" class="log__value strong">
    <a class="ocean" [href]="log.link" target="_blank">{{ log.text }}</a>
  </div>
  <div
    *ngIf="log.type === 'user'"
    class="log__value log__user strong"
    fxLayout
    fxLayoutAlign="start center"
    fxLayoutGap="8px">
    <img class="border-radius-50" [src]="log.image" />
    <span>{{ log.name }}</span>
  </div>

  <ng-container *ngIf="log.type === 'intent_link_list'">
    <div *ngFor="let intent of log.data | keyvalue" class="log__value">
      <a *ngIf="intent.value" class="ocean strong" [href]="'/gx/questions/intent/' + intent.value">{{ intent.key }}</a>
      <span *ngIf="!intent.value">{{ intent.key }}</span>
    </div>
  </ng-container>

  <ng-container *ngIf="log.type === 'ruleset_link_list'">
    <div *ngFor="let intent of log.data | keyvalue" class="log__value">
      <a *ngIf="intent.value" class="ocean strong" [href]="'/gx/rule/' + intent.value">{{ intent.key }}</a>
      <span *ngIf="!intent.value">{{ intent.key }}</span>
    </div>
  </ng-container>
</div>
